/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2022 ООО АДАПТ info@acfs.spb.ru
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import { Box, Stack } from '@mui/material'
import clsx from 'clsx'
import { DisappearedLoading, LoopCircleLoading } from 'react-loadingg'

import logoIcon from '../../assets/img/logo.svg'

import styles from './style.module.scss'

type Props = {
  isPageLoader?: boolean
  isInline?: boolean
  isLogo?: boolean
  dark?: boolean
  height?: number | string
}

const LoadingSpinner = ({ isPageLoader, isInline, isLogo, dark }: Props) => {
  const loadingClasses = clsx({
    [styles.loadingSpinner]: true,
    [styles.loadingSpinner_page]: isPageLoader,
  })

  if (isLogo) {
    return (
      <Stack
        alignItems="center"
        direction="column"
        height="100%"
        justifyContent="center"
        py={6}
      >
        <img
          alt="Logo"
          src={logoIcon}
          style={{ width: '75%', maxWidth: 1024 }}
        />
      </Stack>
    )
  }

  if (isInline) {
    return (
      <Box className={loadingClasses}>
        <div style={{ width: 60 }}>
          <DisappearedLoading
            color={dark ? '#4A5568' : '#ffffff'}
            size="small"
          />
        </div>
      </Box>
    )
  }

  return (
    <div className={loadingClasses}>
      <Box height="250px" position="relative" width="250px">
        <LoopCircleLoading color="#4A5568" size="large" />
      </Box>
    </div>
  )
}

export default LoadingSpinner
